import React from 'react';
import Layout from '../dashboard/layouts/layout';
import DashboardContent from '../dashboard/content/dashboard-content';

function Dashboard() {
    return (
        <Layout>
            <DashboardContent />
        </Layout>
    );
}

export default Dashboard;